import normalize from 'jsonapi-normalizer'
import axios from 'axios'
import * as _ from 'lodash'
import * as config from 'config'
import { getToken } from './JwtTokenUtil'

const formatRequest = (data) => keysToSnakeCase(data)
const formatResponse = ({data}) => keysToCamelCase(data)

const keysToCamelCase = (object) => {
  let camelCaseObject = _.cloneDeep(object)

  if (_.isArray(camelCaseObject)) {
    return _.map(camelCaseObject, keysToCamelCase)
  } else {
    camelCaseObject = _.mapKeys(camelCaseObject, (value, key) => {
      return _.camelCase(key)
    })

    // Recursively apply throughout object
    return _.mapValues(camelCaseObject, (value) => {
      if (_.isPlainObject(value)) {
        return keysToCamelCase(value)
      } else if (_.isArray(value)) {
        return _.map(value, keysToCamelCase)
      } else {
        return value
      }
    })
  }
}

const keysToSnakeCase = (object) => {
  let snakeCaseObject = _.cloneDeep(object)

  if (_.isArray(snakeCaseObject)) {
    return _.map(snakeCaseObject, keysToSnakeCase)
  } else {
    snakeCaseObject = _.mapKeys(snakeCaseObject, (value, key) => {
      return _.snakeCase(key)
    })

    // Recursively apply throughout object
    return _.mapValues(snakeCaseObject, (value) => {
      if (_.isPlainObject(value)) {
        return keysToSnakeCase(value)
      } else if (_.isArray(value)) {
        return _.map(value, keysToSnakeCase)
      } else {
        return value
      }
    })
  }
}

const baseRequest = (callback) => {
  return (url) => {
    return callback(
      url,
      jwtConfig()
    ).then(response => formatResponse(response))
  }
}

const baseDataRequest = (callback) => {
  return (url, data) => {
    return callback(
      url,
      formatRequest(data),
      jwtConfig()
    ).then(response => formatResponse(response))
  }
}

export const getRequest = baseRequest(axios.get)
export const get = (url) => baseRequest(axios.get)(url).then(data => normalize(data))
export const postRequest = baseDataRequest(axios.post)
export const patchRequest = baseDataRequest(axios.patch)

const defaultConfig = (headers) => {
  return {
    headers: { ...headers },
    baseURL: config.baseURL
  }
}

const jsonapiConfig = (headers) => {
  return defaultConfig({
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json',
    ...headers
  })
}

const jwtConfig = (headers) => {
  return jsonapiConfig({
    'Authorization': `Bearer ${getToken()}`
  })
}

export const getFileHeaders = () => {
  return {
    headers: {},
    cache: false,
    dataType: 'json',
    processData: false,
    contentType: false
  }
}

export const getDocumentGeneratorURL = () => {
  return 'http://10.31.27.205:4567'
}

export const buildFormData = (obj) => {
  const formData = new FormData()
  Object.entries(obj).forEach(([key, value]) => formData.append(key, value))
  return formData
}

export const buildUrl = (url, ...filters) => {
  let filterParams = filters.reduce((result, {type, value}) => {
    const final = result[type] ? result[type] : []
    return {
      ...result,
      [type]: [...final, value]
    }
  }, {})

  filterParams = Object.entries(filterParams).reduce((result, [key, value]) => {
    return {
      ...result,
      [key]: value.join(',')
    }
  }, {})

  const params = Object.entries(filterParams)
  const paramSize = params.length - 1
  const suffix = '&'
  const query = params.reduce((result, [key, value], index) => {
    result = `${result}filter[${key}]=${value}`
    if (index !== paramSize) result = result + suffix
    return result
  }, '?')
  return url + query
}

export const attributeFormatter = (type, attributes) => {
  return {
    data: {
      type,
      attributes
    }
  }
}

export const formatImageBase64 = image => `data:image/jpeg;base64, ${image}`
